import { BrightcovePlayer } from '@brightcove/react-player-loader';
import isNil from 'lodash-es/isNil';

import { nr } from '~/src/common/newRelic';
import { isSSR } from '~/src/common/utilities/utilities';

import type NpawPluginAPI from 'npaw-plugin';

import { getYouboraAccountCode } from './getYouboraAccountCode';
import { ExtendedBrightcovePlayer } from '../types';

let NpawPlugin: typeof NpawPluginAPI | null = null;
// Make sure the window object is available to avoid this code to be executed server side
if (typeof window !== 'undefined') {
  // Dynamically import library
  // eslint-disable-next-line global-require
  NpawPlugin = require('npaw-plugin');
}

function isNpawPlugin(target: unknown): target is NpawPluginAPI {
  return target !== null;
}

export function initializeYouboraPlugin(player: BrightcovePlayer | ExtendedBrightcovePlayer) {
  if (isSSR()) {
    return null;
  }
  if (!isNpawPlugin(NpawPlugin)) {
    return null;
  }

  const youboraAccountCode = getYouboraAccountCode();

  let npawPlugin = null;
  if (isNil(youboraAccountCode)) {
    nr.noticeError(new Error('youbora account code is not specified in env variables'));
  } else {
    npawPlugin = new NpawPlugin(youboraAccountCode);

    npawPlugin.registerAdapter(player, '/7.0.4-brightcove-videojs-js.json');
  }

  return npawPlugin;
}
